import { AgentScriptActionType } from '../enums/Enum';

const IsTransferChatActionExists = (option, el) => {
    let isExist = false;
    if (el) {
        option.actions?.filter((action) => {
            if (action.actionType === AgentScriptActionType.transferToLiveAgent) {
                el.setAttribute('data-action-type', 'transfer-chat');
                isExist = true;
            }
        });
    }
    return isExist;
};
export default IsTransferChatActionExists;
